<template>
  <div class="job-list-wrapper">
    <template v-for="(item,index) in listData">
      <div class="list-item" v-if="item.comp_recruit_info"
          :key="index" @click="toDetail(item.comp_recruit_info.token, item.comp_recruit_info.comp_name)">
        <div class="list-avatar flex-center">
          <img :src="item.company_logo" alt=""/>
        </div>
        <div class="list-info">
          <div class="info-title">
            <div class="list-nickname">{{item.comp_recruit_info && item.comp_recruit_info.comp_name}}</div>
            <span @click.stop="collection(item)" class="iconfont"
                  :class="item.job_is_liked ? 'iconstar' : 'iconstar1'"/>
          </div>
          <div class="cities flex-start">
            <span class="iconfont iconmap-pin"/>
            <p class="city-list">
              <span v-for="city in item.city_names" :key="city">{{city}}</span>
            </p>
          </div>
          <div class="list-desc flex-start">
            <span class="iconfont iconclock"/><span>{{item.display_time || "已开始"}}</span>
          </div>
        </div>
      </div>
    </template>
    
  </div>
</template>

<script>
	export default {
		name: 'job-list-campus',
		props: {
			listData: {
				type: Array,
				default: () => []
			}
		},
		data () {
			return {}
		},
		mounted () {
		},
		computed: {},
		watch: {},
		components: {},
		methods: {
			toDetail (token, name) {
				this.$db.ls.set('shareNeed', true)
				this.$emit('toDetail', token, name)
			},
			collection (item) {
				this.$emit('collection', item)
			}
		}
	}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/global/variable';
  @import '@/assets/scss/global/mixin';
  .job-list-wrapper {
    /* height: calc(100vh - 320px);
  position: relative; */
    .img-wrapper {
      width: 100%;
      display: flex;
      justify-content: center;
      position: absolute;
      top: 5px;
      img {
        width: 24px;
        height: 24px;
      }
    }
    .list-item {
      display: flex;
      align-items: center;
      margin-top: 6px;
      font-size: 16px;
      background: $color-light;
      padding: 18px 16px;
      &:last-child {
        margin-right: 0;
      }
      .list-avatar {
        width: 68px;
        height: 68px;
        margin-right: 14px;
        img {
          width: 68px;
          /*height: 68px;*/
        }
      }
      .list-info {
        width: calc(100vw - 114px);
        .info-title {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;
          padding-right: 10px;
          margin-bottom: 12px;
          .list-nickname {
            color: $color-title;
            font-size: $font-size-medium-x;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            max-width: 85%;
          }
          .iconstar1 {
            font-size: 20px;
            color: #d3d3d3;
          }
          .iconstar {
            font-size: 20px;
            color: $color-theme;
          }
        }
        .cities {
          /* display: flex; */
          align-items: center;
          font-size: $font-size-small;
          color: $color-dark-gray;
          margin-bottom: 8px;
          .city-list {
            @include ellipsis(228px)
          }
          span {
            margin-right: 5px;
          }
        }
        .iconclock {
          margin-right: 5px;
        }
        .list-desc {
          display: flex;
          align-items: center;
          font-size: $font-size-small;
          color: $color-dark-gray;
        }
      }
    }
  }
</style>
